import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class CorrectiveActionApi extends BaseApi {
    constructor(client, basePath = '/corrective-action') {
        super(client, basePath);
    }

    async getAll(params = {}) {
        try {
            const response = await this.client.get(this.basePath, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async create(data, queryParams = {}) {
        try {
            const response = await this.client.post(this.basePath, data, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async update(id, data, queryParams = {}) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}`, data, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async delete(id, queryParams = {}) {
        try {
            const response = await this.client.delete(`${this.basePath}/${id}`, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async batchDelete(ids, queryParams = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/batch-delete`, { ids }, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getStats() {
        try {
            const response = await this.client.get(`${this.basePath}/stats`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getExecutionStats(queryParams = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/execution-stats`, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getExecutionTicket(id, queryParams = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/ticket`, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async openExecutionTicket(id, queryParams = {}) {
        try {
            const response = await this.client.post(`${this.basePath}/${id}/open-ticket`, {}, { params: queryParams });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getPartyTemplate(params = {}) {
        try {
            const response = await this.client.get(`${this.basePath}/party-template`, { params });
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async getParty(id) {
        try {
            const response = await this.client.get(`${this.basePath}/${id}/party`);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async syncParty(id, body) {
        try {
            const response = await this.client.put(`${this.basePath}/${id}/party`, body);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
